import { Lock } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function CalScarcity() {
  return (
    <section
      data-testid="cal-scarcity"
      className="py-24 md:py-32 bg-[#3A2E6E] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[36rem] h-[36rem] rounded-full bg-[#C98FA3]/20 blur-[140px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/10 border border-white/20">
            <Lock className="w-5 h-5 text-[#E6D6DF]" />
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <span className="block mt-6 text-sm uppercase tracking-[0.22em] text-[#C98FA3] font-medium">
            — Cadre de travail
          </span>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05] text-white">
            Places limitées
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-8 text-lg text-white/80 leading-relaxed">
            Chaque atelier est volontairement limité en nombre de participants
            pour garantir un cadre de travail de qualité.
          </p>
          <p className="mt-4 text-base text-white/65">
            Il est recommandé de réserver à l'avance.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
